
import telebirrIcon from '../assets/telebirr.png'
import jobImage from '../assets/jobm.jpg'
import beymartImage from '../assets/beymart.jpg'
import gymImage from '../assets/gym.jpg'
import viix from '../assets/viix.jpg'
import rental from '../assets/rental.jpg'
import oneride from '../assets/oneride.jpg'
import virtual from '../assets/virtual.mp4'
import outpatient from '../assets/patient.jpg'
import attendance from '../assets/atendance.jpg'

// Skills Data - Devicon for most, Simple Icons for icons that don't load from Devicon
const devicon = (name, style = 'original') =>
    `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/${name}/${name}-${style}.svg`
// Simple Icons CDN - reliable fallback for GraphQL, Stripe, Telegram, Next.js
const simpleIcon = (slug) => `https://cdn.simpleicons.org/${slug}`

export const skills = [
    { name: 'Node.js', icon: devicon('nodejs') },
    { name: 'GraphQL', icon: simpleIcon('graphql') },
    { name: 'Flutter', icon: devicon('flutter') },
    { name: 'Vue.js', icon: devicon('vuejs') },
    { name: 'Next.js', icon: simpleIcon('nextdotjs') },
    { name: 'Electron.js', icon: devicon('electron') },
    { name: 'Telegram Bot', icon: simpleIcon('telegram') },
    { name: 'Stripe Payment', icon: simpleIcon('stripe') },
    { name: 'TeleBirr Payment', icon: telebirrIcon },
    { name: 'MySQL', icon: devicon('mysql') },
    { name: 'MongoDB', icon: devicon('mongodb') },
    { name: 'PostgreSQL', icon: devicon('postgresql') }
]

export const projects = [
    {
        id: 1,
        title: 'Job Posting Bot with Mini App',
        shortDescription: 'A Telegram bot, Telegram channel and mini app reaching 11,000+ users, allowing employers to post jobs, manage applicants, and for employees to apply and submit CVs securely.',
        fullDescription: 'This project is a Telegram bot integrated with a mini app, reaching over 11,000 active users. It enables employers to post job listings, manage applicants, and filter candidates efficiently. Employees can apply directly through the system, uploading their CVs and related documents. Payments are handled manually via screenshot verification. The admin dashboard allows monitoring of job posts, applications, and payment verification, ensuring smooth and secure interactions between employers and job seekers.',
        media: jobImage,
        mediaType: 'image',
        technologies: ['Node.js', 'GraphQL', 'Vue.js', 'Express', 'Telegram Bot API', 'MySQL'],
        features: [
            'Employers can post and manage job listings',
            'Employees can apply directly through the system',
            'Applicants can upload CVs and related documents',
            'Candidate filtering system for easy applicant management',
            'Mini app integration for seamless interaction',
            'Manual payment processing with screenshot verification',
            'Admin dashboard for monitoring jobs, applicants, and payments',
            'Reaches 11,000+ active users, demonstrating scalability and reliability'
        ],
        challenges: 'The main challenge was enabling the bot to interact with Telegram channels while passing a parameterized URL for each job post, allowing the system to identify which post an employee is applying for. I solved this by implementing dynamic URLs linked to each job and ensuring secure backend handling to correctly map applications to the right listings.',
        link: 'https://t.me/addis_ababa_jobs',
        // githubLink: 'https://github.com/example/job-bot'
    }
    ,
    {
        id: 2,
        title: 'Beymart E-commerce Platform',
        shortDescription: 'A comprehensive e-commerce platform supports global payment methods, it includes buyers, suppliers, drivers, and admins across web and mobile with multiple payment options.',
        fullDescription: 'Beymart is a full-featured e-commerce platform with web and mobile apps, supporting buyers, suppliers, drivers, and an admin portal. Users can browse products, place orders, track deliveries, and make payments via Stripe or local money transfer. Suppliers can manage inventory, process orders, and coordinate with drivers for deliveries. Drivers can be assigned to orders automatically or manually, optimizing delivery routes using Google Maps APIs for real-time fee and distance calculation. As a full-stack developer, I worked with Node.js, GraphQL, Flutter, Vue.js, and MySQL to build scalable, secure, and efficient systems. It is now out of market.',
        media: beymartImage,
        mediaType: 'image',
        technologies: ['Node.js', 'Flutter', 'GraphQL', 'Vue.js', 'MySQL', 'Google Maps API', 'Stripe API', 'Redis', 'Socket.io', 'Docker', 'Nginx'],
        features: [
            'Buyer, supplier, driver, and admin portals on web and mobile',
            'Product catalog management and inventory tracking',
            'Order placement, tracking, and management',
            'Driver assignment and delivery route optimization using Google Maps APIs',
            'Payment processing via Stripe and local money transfer',
            'Real-time notifications and updates',
            'Admin dashboard for analytics and monitoring',
            'Mobile-responsive and user-friendly interfaces'
        ],
        challenges: 'One of the biggest challenges was integrating Stripe to handle multiple currencies, recurring payments, partial refunds, and ensuring PCI compliance. Many developers face issues like payment synchronization errors, failed webhook events, and maintaining consistent payment status across different portals. I solved this by implementing server-side webhook verification to confirm payment events, using idempotent requests to prevent duplicate charges, and building an automated reconciliation system that syncs Stripe transactions with the backend database to ensure accurate and reliable payment tracking. Another challenge was implementing driver assignment and delivery optimization to ensure timely deliveries. I solved this by developing a backend system that dynamically assigns drivers to orders, calculates routes using Google Maps APIs, and ensures synchronized updates across all portals.',
        // link: '#',
        // githubLink: '#'
    }
    ,
    {
        id: 3,
        title: 'Ride-Hailing & Driver Dispatch Platform – One Ride',
        shortDescription: 'A real-time ride-hailing platform with passenger, driver, and admin applications, including shared ride and split-payment functionality.',
        fullDescription: 'One Ride is a full-scale on-demand ride-hailing platform designed to connect passengers and drivers in real time. The system includes separate mobile applications for passengers and drivers, along with a powerful admin dashboard for system monitoring and fleet management. Key features include live ride tracking, automated fare calculation, ride-sharing (multiple passengers sharing one trip), and split-payment functionality. Built with a scalable architecture using Node.js, Flutter, React, Redis, and Socket.io, the platform ensures real-time communication, optimized route calculation, and high performance under heavy user activity.',
        media: oneride,
        mediaType: 'image',
        technologies: [
            'Node.js',
            'Flutter',
            'React',
            'MySQL',
            'Redis',
            'Socket.io',
            'Google Maps API',
            'Google Distance Matrix API',
            'JWT Authentication',
            'Docker'
        ],
        features: [
            'Passenger mobile app for booking and tracking rides',
            'Driver mobile app with ride request management',
            'Admin dashboard for monitoring rides and users',
            'Real-time ride tracking using Socket.io',
            'Ride-sharing functionality (multiple passengers per trip)',
            'Split-payment system for shared rides',
            'Automated fare calculation based on distance and time',
            'Google Maps integration for routing and navigation',
            'Driver availability and location tracking',
            'Trip history and earnings reports',
            'Role-based authentication and secure APIs'
        ],
        challenges: 'Implementing real-time ride matching and live location tracking while maintaining system performance was a major challenge. I used Redis for temporary ride state management and Socket.io for real-time communication between passengers and drivers. Designing the shared ride logic required dynamic fare splitting and route optimization using Google APIs. Ensuring accurate trip state transitions (requested, accepted, started, completed, canceled) required careful backend architecture and concurrency handling.',
        link: 'https://play.google.com/store/apps/details?id=com.onerideet.onepassenger',

    }



    ,
    {
        id: 4,
        title: 'Multi-Role Store Tracking & POS Management System',
        shortDescription: 'A full-featured store management and POS system with cashier operations, inventory control, reporting dashboards, and multi-role access management.',
        fullDescription: 'A comprehensive Store Tracking and POS Management System designed to streamline retail operations. The platform includes a cashier mobile application for daily sales transactions and web-based Admin and Super Admin portals for centralized management. It enables real-time inventory tracking, sales monitoring, expense recording, and advanced reporting with graphical analytics and PDF exports. The system is built to support scalable multi-branch operations with secure role-based access control and deployed on play store.',
        media: viix,
        mediaType: 'image',
        technologies: ['Node.js', 'Flutter', 'GraphQL', 'Vue.js', 'MySQL'],
        features: [
            'Cashier POS system for daily sales transactions',
            'Admin and Super Admin role-based dashboards',
            'Real-time inventory and stock management',
            'Sales, expense, and profit tracking',
            'Automated daily, weekly, and monthly summaries',
            'Advanced reporting with graphical analytics',
            'PDF report generation and export functionality',
            'Multi-branch store support',
            'User and role permission management',
            'Secure authentication and authorization'
        ],
        // challenges: 'One of the key challenges was maintaining real-time synchronization between cashier devices and the admin dashboard while ensuring data consistency across multiple branches. I implemented a GraphQL-based architecture with optimized queries and structured transaction handling in MySQL to ensure accuracy and performance. Additionally, generating dynamic PDF reports and large-scale sales summaries required careful query optimization and backend performance tuning.',
        link: 'https://play.google.com/store/apps/details?id=com.abima.invmanager',

    }
    ,
    {
        id: 5,
        title: 'Broker-Free Rental Bot & Mini App – Yale Delala',
        shortDescription: 'A Telegram-based broker-free rental platform reaching 6,700+ active users in 4 months, allowing property owners and tenants to interact directly with real-time listings.',
        fullDescription: 'Yale Delala is a broker-free rental platform with a Telegram bot and mini app, designed to connect property owners directly with tenants. The platform allows owners to post listings, upload photos, and share details, while tenants can browse properties, apply directly, and schedule viewings. Advanced search filters, and Sales platform provide a seamless user experience. As a full-stack developer, I implemented the system using Node.js,GraphQL, Vue.js, MySQL, and cloud hosting to ensure scalability, speed, and reliability. The platform achieved 6,700+ active users within the first four months, demonstrating high adoption and impact.',
        media: rental,
        mediaType: 'image',
        technologies: ['Node.js', 'Vue.js', 'GraphQL', 'Express', 'Telegram Bot API', 'Redis', 'Socket.io', 'MySQL'],
        features: [
            'Owners can post and manage rental listings',
            'Tenants can browse, filter, and favorite properties',
            'Direct tenant-owner communication via Telegram bot',
            'Admin dashboard for monitoring listings and users',
            'Real-time notifications for new listings and updates',
            'Supports 6,700+ active users with scalable architecture'
        ],
        challenges: 'The main challenge was integrating the Telegram bot with multiple channels and passing parameterized URLs for each property post, ensuring the system correctly identifies which listing a tenant interacts with. Additionally, handling large datasets and optimizing search performance for thousands of listings required database indexing, caching strategies with Redis, and efficient query design in MySQL. I solved these by implementing a robust backend system with real-time updates via Socket.io, optimized search queries, and secure bot-channel communication.',
        link: 'https://t.me/yaledelala', // Private bot, not publicly accessible
        // githubLink: '#' // Private codebase
    }
    ,
    {
        id: 6,
        title: 'Smart Gateway Attendance System',
        shortDescription: 'An IoT-based attendance management system for real-time employee check-in/out monitoring using smart gateway devices.',
        fullDescription: 'A Smart Gateway Attendance System developed for a private client to automate and monitor employee attendance in real time. The system integrates physical gateway devices for check-in/check-out tracking and synchronizes data instantly to a centralized platform. It includes a mobile application for employees and a web-based admin dashboard for HR and management teams. Built using Node.js, Vue.js, Flutter, and MongoDB, the system ensures secure authentication, accurate time tracking, and detailed reporting for workforce management.',
        media: attendance,
        mediaType: 'image',
        technologies: [
            'Node.js',
            'Vue.js',
            'Flutter',
            'MongoDB',
            'Socket.io',
            'JWT Authentication',
            'REST API',
            'Docker'
        ],
        features: [
            'Smart gateway-based employee check-in/check-out',
            'Real-time attendance synchronization',
            'Employee mobile app for attendance history',
            'Admin dashboard for attendance monitoring',
            'Late arrival and overtime tracking',
            'Department and role-based employee grouping',
            'Automated daily, weekly, and monthly attendance reports',
            'Exportable reports (PDF/CSV)',
            'Secure authentication and access control',
            'Attendance analytics and summary dashboards'
        ],
        challenges: 'Ensuring real-time synchronization between physical gateway devices and the central system was a key challenge. I implemented a robust API layer with Socket.io to handle instant updates and prevent duplicate attendance entries. Designing a flexible MongoDB schema to manage large attendance logs while maintaining fast query performance required proper indexing and optimized aggregation pipelines.',

        githubLink: 'https://github.com/wendmsoft/gateway_attendance_backend'
    }
    ,
    {
        id: 7,
        title: 'Real-Time Virtual Gaming Platform – Keno, Spin, Racing & Bingo',
        shortDescription: 'A real-time multiplayer virtual gaming platform featuring Keno, Spin Wheel, Car/Dog/Horse Racing, and Bingo with live results and automated payouts.',
        fullDescription: 'A scalable real-time virtual gaming platform that offers multiple interactive games including Keno, Spin Wheel, Racing (Car, Dog, Horse), and Bingo. The system supports thousands of concurrent users with live game sessions, automated result generation, and dynamic payout calculations. Built with a high-performance backend using Node.js, Redis, and Socket.io to ensure real-time synchronization across all connected players. The platform includes an admin panel for game control, odds configuration, reporting, and financial monitoring.',
        media: virtual,
        mediaType: 'video',
        technologies: [
            'Node.js',
            'Vue.js',
            'Flutter',
            'MySQL',
            'Redis',
            'Socket.io',
            'JWT Authentication',
            'Docker',
            'Nginx'
        ],
        features: [
            'Multiple real-time games (Keno, Spin, Racing, Bingo)',
            'Live multiplayer game sessions',
            'Automated random result generation logic',
            'Real-time betting and instant result updates',
            'Dynamic odds and payout management',
            'User wallet and balance tracking system',
            'Admin dashboard for game control and monitoring',
            'Financial reports and transaction history',
            'Scalable architecture supporting high concurrency',
            'Secure authentication and fraud-prevention logic'
        ],
        challenges: 'Ensuring real-time synchronization for thousands of concurrent players during live game sessions was a significant challenge. I implemented Redis for temporary game state management and Socket.io for real-time event broadcasting. Designing fair and secure result generation logic required careful backend control and transaction validation to prevent race conditions and inconsistencies. Optimizing database performance for high-frequency betting transactions was achieved through indexing and efficient query design in MySQL.'
        ,

    }
    ,
    {
        id: 8,
        title: 'Outpatient Management System for Clinics',
        shortDescription: 'A comprehensive outpatient management platform designed for small and medium clinics to manage patient records, appointments, billing, and clinical workflows.',
        fullDescription: 'A full-featured Outpatient Management System built to streamline operations for small and medium-sized clinics. The platform enables healthcare providers to manage patient registrations, appointments, medical records, prescriptions, and billing processes efficiently. It centralizes all outpatient activities into a secure digital system, improving record accuracy, reducing paperwork, and enhancing clinic workflow visibility. Built with Node.js, GraphQL, Vue.js, and MySQL, the system ensures data integrity, scalability, and secure access to sensitive patient information.',
        media: outpatient,
        mediaType: 'image',
        technologies: [
            'Node.js',
            'GraphQL',
            'Vue.js',
            'MySQL',
            'JWT Authentication',
            'Role-Based Access Control (RBAC)',
            'PDF Generation',
            'Docker'
        ],
        features: [
            'Patient registration and profile management',
            'Appointment scheduling and queue management',
            'Electronic medical records (EMR) system',
            'Prescription and treatment tracking',
            'Billing and invoice generation',
            'Doctor and staff role-based access control',
            'Daily patient visit summaries and reports',
            'Analytics dashboard for clinic performance',
            'Secure authentication and data protection',
            'Exportable reports in PDF format'
        ],
        // challenges: 'Ensuring secure handling of sensitive patient medical data while maintaining performance was a major challenge. I implemented strict role-based access control (RBAC), JWT-based authentication, and optimized GraphQL queries to prevent over-fetching. Designing a flexible medical record schema in MySQL that supports structured and evolving patient data required careful database modeling and indexing strategies to maintain performance as records grow.',
        link: 'https://outpatient.desalegntentprduction.com/',
        // githubLink: '#'
    }
    ,
    {
        id: 9,
        title: 'Gym Monitoring System',
        shortDescription: 'A comprehensive gym management platform for Fira Sport, enabling member tracking, attendance, class scheduling, and analytics.',
        fullDescription: 'This Gym Monitoring System was developed for Fira Sport, a private client, to streamline their gym operations. It allows staff to track member registrations, attendance, subscriptions, and class schedules, while members can view workout plans, track progress, and receive class notifications. The platform includes detailed analytics and reports on gym performance and revenue. As a full-stack developer, I worked with Node.js, Vue.js, GraphQL, and MySQL to deliver a secure, scalable, and intuitive solution.',
        media: gymImage,
        mediaType: 'image',
        technologies: ['Node.js', 'Vue.js', 'GraphQL', 'MySQL', 'Chart.js', 'REST API', 'Docker', 'Nginx'],
        features: [
            'Member registration and profile management',
            'Attendance tracking and check-in system',
            'Class and trainer scheduling',
            'Subscription and payment management',
            'Workout plans and progress tracking for members',
            'Analytics and reporting dashboard for gym performance',
            'Notifications and reminders for classes and events',
            'Role-based access for staff and admins',
            'Mobile-responsive and user-friendly interface'
        ],
        // challenges: 'Integrating real-time attendance tracking and class scheduling while ensuring accurate analytics was challenging. I implemented GraphQL subscriptions for real-time updates, optimized queries for performance, and designed a robust backend with Node.js and MySQL to handle large datasets efficiently.',
        link: 'https://ala.abimabusiness.com', // Private project, no public link
        // githubLink: '#' // Private project, no public repository
    }


]
